import Grid from '@highcharts/grid-lite/es-modules/masters/grid-lite.src.js';
import { getPoliceData } from './chart-police.js';
import { research } from '../ranking-sm/data.js';

function fmt(value, decimals, suffix = '') {
    if (value === null || value === undefined) return '–';
    return value.toLocaleString('en-US', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    }) + suffix;
}

/**
 * @param {string} id
 */
export default function gridEfficiency(id) {
    if (!document.getElementById(id)) return;

    const policeData = getPoliceData();
    const policeByCity = {};
    policeData.forEach(d => { policeByCity[d.city] = d; });

    const rows = research.map(r => {
        const d = policeByCity[r.city] || {};
        const smFines = d.smFines || 0;
        const policeFines = d.policeFines || 0;

        const dailySM = smFines > 0 ? Math.round(smFines / 365 * 10) / 10 : null;
        const dailyPol = policeFines > 0 ? Math.round(policeFines / 365 * 10) / 10 : null;

        const maxSM = smFines > 0 ? Math.round((smFines / 365 / r.count) * 10000) / 100 : null;
        const maxPol = policeFines > 0 ? Math.round((policeFines / 365 / r.count) * 10000) / 100 : null;

        const totalMax = (maxSM ?? 0) + (maxPol ?? 0);
        const minTotal = r.residentPercent != null
            ? Math.round(totalMax * (r.residentPercent / 100) * 100) / 100
            : null;

        return {
            city: r.city,
            illegalCars: r.count,
            illegalCarsCity: Math.round(r.count / (r.residentPercent / 100)),
            residentPercent: r.residentPercent,
            dailySM,
            dailyPol,
            daily: (dailySM ?? 0) + (dailyPol ?? 0),
            max: (maxSM ?? 0) + (maxPol ?? 0),
            minTotal,
            policeEstimated: d.estimated || false
        };
    });

    Grid.grid(id, {
        dataTable: {
            columns: {
                "City": rows.map(r => r.city),
                "Illegally parked<br>(area &amp; city)": rows.map(r => `${fmt(r.illegalCars)}/area<br>~${fmt(r.illegalCarsCity)}/city`),
                "Fines / day<br>(guards + police)": rows.map(r => `${fmt(r.dailySM, 0, '')} + ${fmt(r.dailyPol, 0, '')} = ${fmt(r.daily, 0, '')}`),
                "Fine<br>probability": rows.map(r =>
                    r.residentPercent > 5 ?
                        fmt(r.minTotal, 2, '%') + ' ~ ' + fmt(r.max, 1, '%') :
                        '~ ' + fmt(r.minTotal, 2, '%'))
            }
        },
        rendering: {
            rows: { strictHeights: false },
            theme: 'hcg-theme-default theme-compact'
        },
        columns: [
            { id: "City", cells: { className: 'bold' } },
            { id: "Illegally parked<br>(area &amp; city)", cells: { className: 'cell-right' } },
            { id: "Fines / day<br>(guards + police)", cells: { className: 'cell-right' } },
            { id: "Fine<br>probability", cells: { className: 'cell-right' } }
        ]
    });
}
